module.exports = __webpack_public_path__ + "img/section1_tooliaba_logo.16ff4caf.svg";